import React, { useState } from 'react';
import { Spin } from 'antd';

// Кадр с SVG-слоем в координатах исходного изображения.
// Клик пересчитывается из экранных пикселей в пиксели кадра — именно их ждёт сервер.
// children — функция (size) => SVG-элементы, size = { w, h, unit }, unit — удобный размер маркера.
const FrameCanvas = ({ src, onPick, children, cursor = 'crosshair' }) => {
    const [size, setSize] = useState(null);

    const handleClick = (e) => {
        if (!onPick || !size) return;
        const rect = e.currentTarget.getBoundingClientRect();
        const x = ((e.clientX - rect.left) * size.w) / rect.width;
        const y = ((e.clientY - rect.top) * size.h) / rect.height;
        onPick(Math.round(x), Math.round(y));
    };

    return (
        <div style={{ position: 'relative', width: '100%', lineHeight: 0, borderRadius: 8, overflow: 'hidden', background: '#000' }}>
            <img
                src={src}
                alt=""
                draggable={false}
                onLoad={(e) => setSize({
                    w: e.currentTarget.naturalWidth,
                    h: e.currentTarget.naturalHeight,
                    unit: Math.max(e.currentTarget.naturalWidth, e.currentTarget.naturalHeight) / 160,
                })}
                style={{ width: '100%', display: 'block', userSelect: 'none' }}
            />
            {!size && (
                <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Spin />
                </div>
            )}
            {size && (
                <svg
                    viewBox={`0 0 ${size.w} ${size.h}`}
                    preserveAspectRatio="none"
                    onClick={handleClick}
                    style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', cursor: onPick ? cursor : 'default' }}
                >
                    {children && children(size)}
                </svg>
            )}
        </div>
    );
};

export const Marker = ({ x, y, unit, color, label, active }) => (
    <g pointerEvents="none">
        {active && <circle cx={x} cy={y} r={unit * 2.4} fill="none" stroke="#fff" strokeWidth={unit * 0.35} />}
        <circle cx={x} cy={y} r={unit * 1.5} fill={color} stroke="#fff" strokeWidth={unit * 0.3} />
        <text
            x={x}
            y={y}
            fill="#fff"
            fontSize={unit * 1.7}
            fontWeight="700"
            textAnchor="middle"
            dominantBaseline="central"
        >
            {label}
        </text>
    </g>
);

export const Line = ({ a, b, unit, color, dashed }) => (
    <line
        x1={a[0]} y1={a[1]} x2={b[0]} y2={b[1]}
        stroke={color}
        strokeWidth={unit * 0.5}
        strokeDasharray={dashed ? `${unit * 1.5} ${unit}` : undefined}
        pointerEvents="none"
    />
);

export default FrameCanvas;
